"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");
/*
 * Created on 20/08/2018
 */

/**
 * Data transfer object describing row in Price Architecture containing values such as number of products,
 * number of new products with or without recommendation, number of families, number of not-assigned products.
 *
 * @author JMr
 *
 */
// TODO ZSt extends with sub category count attribute


var PriceArchitectureDTO =
/*#__PURE__*/
function () {
  /**
   * Represents line in price architecture
   */
  function PriceArchitectureDTO(id, categoryId, newWithRecommended, newWithoutRecommended, totalProducts, notAssignedProducts, numberOfFamilies, level, parentId, childrenCount) {
    _classCallCheck(this, PriceArchitectureDTO);

    this.id = id;
    this.categoryId = categoryId;
    this.newWithRecommended = newWithRecommended;
    this.newWithoutRecommended = newWithoutRecommended;
    this.totalProducts = totalProducts;
    this.notAssignedProducts = notAssignedProducts;
    this.numberOfFamilies = numberOfFamilies;
    this.level = level;
    this.parentId = parentId;
    this.childrenCount = childrenCount; // not implemented
  }

  _createClass(PriceArchitectureDTO, [{
    key: "setCategoryTreeIdentification",
    value: function setCategoryTreeIdentification(parentId, level) {
      return new PriceArchitectureDTO(this.id, this.categoryId, this.newWithRecommended, this.newWithoutRecommended, this.totalProducts, this.notAssignedProducts, this.numberOfFamilies, level ? level : this.level, parentId ? parentId : this.parentId, this.childrenCount);
    }
  }, {
    key: "incrementCounts",
    value: function incrementCounts(newWithRecommended, newWithoutRecommended, totalProducts, notAssignedProducts, numberOfFamilies) {
      return new PriceArchitectureDTO(this.id, this.categoryId, this.newWithRecommended + newWithRecommended, this.newWithoutRecommended + newWithoutRecommended, this.totalProducts + totalProducts, this.notAssignedProducts + notAssignedProducts, this.numberOfFamilies + numberOfFamilies, this.level, this.parentId, this.childrenCount);
    }
  }]);

  return PriceArchitectureDTO;
}();

exports.PriceArchitectureDTO = PriceArchitectureDTO; // tslint:disable-next-line:member-ordering

PriceArchitectureDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PriceArchitectureDTO.name);
  return {
    id: builder.id('_id'),
    categoryId: builder.id('categoryId'),
    newWithRecommended: builder.num('newWithRecommended'),
    newWithoutRecommended: builder.num('newWithoutRecommended'),
    totalProducts: builder.num('totalProducts'),
    notAssignedProducts: builder.num('notAssignedProducts'),
    numberOfFamilies: builder.num('numberOfFamilies'),
    level: builder.num('level'),
    parentId: builder.str('parentId'),
    childrenCount: builder.num('childrenCount')
  };
}();